exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".enneagrammyQuestion {\n  position: relative;\n  width: 100vw;\n  height: 200px;\n  float: left;\n}", ""]);

